import React, {Fragment} from 'react'
import {Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import {TextField} from 'formik-material-ui'
import {StepHeader} from '../../styles'

const Step4 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Seus dados
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Field
          name="name"
          label="Qual é o seu nome completo?"
          helperText="Como está escrito na sua identidade"
          fullWidth
          component={TextField}
        />
      </Grow>
    </Fragment>
  );
};

export default Step4;
